export default "__VITE_ASSET__8e0fbee1__"